import { MLM } from '@sunrise/tracking'

import { ActionIds, MLMData } from '../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../ts/tracking/mlmStaticTrackingData'
import { CompanyName, TypePaid } from '../../ts/utils/trackingUtils.enum'

export function buildMlmTrackingData(
    actionId: ActionIds,
    componentId: string,
    currentUrl: string,
    exposeeId: number,
): MLM.TrackingData {
    return {
        ...staticMlmTrackingData,
        page: MLMData.DEFAULT_PAGE as number,
        actionId,
        componentId,
        pageUrl: currentUrl,
        items: [buildMlmItems(exposeeId)],
    }
}

function buildMlmItems(exposeeId: number): MLM.Item {
    return {
        id: exposeeId.toString(),
        type: CompanyName.OWN_INVENTORY,
        typePaid: TypePaid.OWN_INVENTORY,
        typePosition: 1,
    }
}
